import { render } from "./imagegallary.vue?vue&type=template&id=e0a2d8ca&scoped=true"
import script from "./imagegallary.vue?vue&type=script&lang=js"
export * from "./imagegallary.vue?vue&type=script&lang=js"

import "./imagegallary.vue?vue&type=style&index=0&id=e0a2d8ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a2d8ca"]])

export default __exports__